import {
  getByContentType,
  determine_locale,
} from "../../../plugins/contentful";

export default {
  getWebstoreContent: async ({ rootState, commit }) => {
    try {
      let locale = determine_locale(rootState.checkout.writtenLanguage, rootState.billing.country);
      let ctful = await getByContentType("webstore", locale, {
        "sys.id": "2627EtPzImOU22TwpPGCIt",
      });
      commit("setWebstoreContent", ctful);
    } catch (e) {
      this.$router.push({path: "/message", query: { type: "errorCheckingOut" }});
    }
  },

  getCheckoutContent: async ({ rootState, commit }) => {
    try {
      let locale = determine_locale(rootState.checkout.writtenLanguage, rootState.billing.country);
      let checkoutContent = await getByContentType("checkout", locale, { "sys.id": "3nxvs8sqzSSScM4Eq224WG" });
      commit("setCheckoutContent", checkoutContent);
      commit("setCheckoutSharedContent", checkoutContent["checkoutSharedContent"]["fields"]);
    } catch (e) {
      this.$router.push({path: "/message", query: { type: "errorCheckingOut" }});
    }
  },

  getFooterContent: async ({ rootState }) => {
    try {
      let locale = determine_locale(rootState.checkout.writtenLanguage, rootState.billing.country);
      return await getByContentType("footer", locale, { "sys.id": "3K0Jgh0vZuqqUgWAYOYUco" });
    } catch (e) {
      this.$router.push({path: "/message", query: { type: "errorCheckingOut" }});
    }
  },

  getWebstoreProductContent: async ({ rootState }) => {
    try {
        let locale = determine_locale(rootState.checkout.writtenLanguage, rootState.billing.country);
        return await getByContentType('productGroup', locale, { 'sys.id': '3HmInJccvFgOOfzKXLlKku', include: 7 });
    } catch (e) {
        this.$router.push({path: '/message', query: {type: 'errorCheckingOut'}});   
    }
  },

  getWebstoreGlobals: async ({ rootState, commit }) => {
    try {
      let locale = determine_locale(rootState.checkout.writtenLanguage, rootState.billing.country);
      let webstoreGlobals = await getByContentType("corpwebDb", locale, { "sys.id": "5evyBd24oj4PzMWZs86DI" });
      commit("setWebstoreGlobals", webstoreGlobals);
    } catch (e) {
      this.$router.push({path: "/message", query: { type: "errorCheckingOut" }});
    }
  },

  getRenewalsPersistedVariables: async ({ rootState, commit }) => {
    try {
      const ctfulEntryId = "6mcR2PpUGJMIDYCeKdTTor";
      let locale = determine_locale(rootState.checkout.writtenLanguage, rootState.billing.country);
      let renewalsPersistedVariables = await getByContentType("renewalsPersistedVariables", locale, { "sys.id": ctfulEntryId });
      if (!renewalsPersistedVariables.jsonContent) {
        renewalsPersistedVariables = await getByContentType("renewalsPersistedVariables", "en-US", {'sys.id': ctfulEntryId });
      }
      commit("setRenewalsPersistedVariables", renewalsPersistedVariables);
    } catch (e) {
      this.$router.push({path: "/message", query: { type: "errorCheckingOut" }});
    }
  },
};
